document.addEventListener('DOMContentLoaded', () => {
	const selects = document.querySelectorAll('.menu-banner-select');

	// ---------------------------------------------------------
	// Fonction pour décoder les entités HTML
	// ---------------------------------------------------------

	const decodeHtmlEntities = (str) => {
		const txt = document.createElement('textarea');
		txt.innerHTML = str || '';
		return txt.value;
	};

	// ---------------------------------------------------------
	// Initialisation de chaque menu
	// ---------------------------------------------------------

	selects.forEach((select) => {
		const nav = select.closest('.menu-banner-nav');

		if (!nav) return;

		const button = nav.querySelector(
			'.menu-banner-select__button'
		);

		const label = nav.querySelector(
			'.menu-banner-select__label'
		);

		const desktopOptions = Array.from(
			nav.querySelectorAll(
				'.menu-banner-list.desktop li'
			)
		);

		const mobileOptions = Array.from(
			nav.querySelectorAll(
				'.menu-banner-list.mobile li'
			)
		);

		const allOptions = [
			...desktopOptions,
			...mobileOptions,
		];

		// -----------------------------------------------------
		// Vérifie si une URL est externe
		// -----------------------------------------------------

		const isExternalUrl = (url) => {
			return /^https?:\/\//i.test(url || '');
		};

		// -----------------------------------------------------
		// Met en surbrillance la page actuelle
		// -----------------------------------------------------

		const highlightCurrentPage = () => {
			const currentPath =
				window.location.pathname.replace(/\/$/, '');

			allOptions.forEach((option) => {
				const href =
					option.dataset.value?.trim();

				// Pas d'URL
				if (!href) {
					option.classList.remove('selected');
					return;
				}

				// Les liens externes ne peuvent pas
				// correspondre à la page actuelle
				if (isExternalUrl(href)) {
					option.classList.remove('selected');
					return;
				}

				const normalizedHref =
					href.replace(/\/$/, '');

				if (
					normalizedHref &&
					currentPath.startsWith(
						normalizedHref
					)
				) {
					option.classList.add('selected');
				} else {
					option.classList.remove(
						'selected'
					);
				}
			});

			// -------------------------------------------------
			// Détermine l'option active
			// -------------------------------------------------

			const activeOption =
				allOptions.find((option) =>
					option.classList.contains('selected')
				) || allOptions[0];

			// -------------------------------------------------
			// Met à jour le bouton mobile
			// -------------------------------------------------

			if (activeOption) {
				const activeLink =
					activeOption.querySelector('a');

				if (label) {
					label.textContent =
						decodeHtmlEntities(
							activeLink?.textContent
						);
				}

				select.dataset.value =
					activeOption.dataset.value || '';
			}
		};

		highlightCurrentPage();

		// -----------------------------------------------------
		// Toggle du menu mobile
		// -----------------------------------------------------

		const toggle = (open) => {
			const willOpen =
				typeof open === 'boolean'
					? open
					: !select.classList.contains('open');

			if (willOpen) {
				select.classList.remove('closing');
				select.classList.add('open');

				select.setAttribute(
					'aria-expanded',
					'true'
				);

				const current =
					allOptions.find(
						(option) =>
							option.dataset.value ===
							select.dataset.value
					) || allOptions[0];

				current?.focus();
			} else {
				select.classList.remove('open');
				select.classList.add('closing');

				select.setAttribute(
					'aria-expanded',
					'false'
				);

				setTimeout(() => {
					select.classList.remove(
						'closing'
					);
				}, 120);

				button?.focus();
			}
		};

		// -----------------------------------------------------
		// Ouverture / fermeture du menu
		// -----------------------------------------------------

		button?.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			toggle();
		});

		// -----------------------------------------------------
		// Clic sur une option
		// -----------------------------------------------------

		allOptions.forEach((option) => {
			option.addEventListener('click', (event) => {
				const href =
					option.dataset.value?.trim();

				if (!href) return;

				const link =
					option.querySelector('a');

				const text =
					decodeHtmlEntities(
						link?.textContent
					);

				// ---------------------------------------------
				// Supprime selected sur toutes les options
				// ---------------------------------------------

				allOptions.forEach((o) =>
					o.classList.remove('selected')
				);

				// ---------------------------------------------
				// Sélectionne l'option cliquée
				// ---------------------------------------------

				option.classList.add('selected');

				// ---------------------------------------------
				// Met à jour le bouton mobile
				// ---------------------------------------------

				if (label) {
					label.textContent = text;
				}

				select.dataset.value = href;

				// ---------------------------------------------
				// Navigation
				// ---------------------------------------------
				//
				// IMPORTANT :
				// On ne fait volontairement PAS :
				//
				// window.location.href = href;
				//
				// Le lien <a> prend en charge la navigation.
				// Cela permet notamment à target="_blank"
				// de fonctionner pour les liens externes.
				// ---------------------------------------------

				toggle(false);
			});
		});

		// -----------------------------------------------------
		// Ferme le menu si clic à l'extérieur
		// -----------------------------------------------------

		document.addEventListener('click', (event) => {
			if (
				!select.contains(event.target) &&
				select.classList.contains('open')
			) {
				toggle(false);
			}
		});

		// -----------------------------------------------------
		// Met à jour le selected lors du redimensionnement
		// -----------------------------------------------------

		window.addEventListener(
			'resize',
			highlightCurrentPage
		);
	});
});
